// Permisos RBAC de Modelia. Están ENCENDIDOS: los endpoints los exigen, así que la pantalla se
// esconde hasta que el rol los tenga sembrados (fail-closed).
/**
 * Claves de permiso de la pantalla. Van como `string` y no como `Permission` porque
 * `PermissionKey` (generado del OpenAPI) hoy no expone ninguna clave de dominio.
 */
export const MODELIA_PERMISSIONS = {
    viewEvaluations: 'loan.scoring.read',
    viewParameters: 'loan.parameter.read',
    rerunEvaluations: 'loan.scoring.write',
} as const;

export type ModeliaPermissionKey = (typeof MODELIA_PERMISSIONS)[keyof typeof MODELIA_PERMISSIONS];

/** El 403 del listado: nombra su permiso y el endpoint, porque culpar al equivocado hace que se
 *  siembre el permiso que no era. */
export const MODELIA_FORBIDDEN_DESCRIPTION =
    'Ver las evaluaciones del motor requiere el permiso loan.scoring.read (GET /scoring/evaluations). Pídeselo a tu administrador para tu rol.';

/** El gate está encendido. Sin las claves sembradas la pantalla queda oculta: es lo correcto. */
export const MODELIA_PERMISSIONS_ENFORCED = true;

export interface ModeliaAbilities {
    canViewEvaluations: boolean;
    /** Solo apaga el diálogo del modelo; la pantalla entera sigue en pie sin este permiso. */
    canViewParameters: boolean;
    /** Sin esta clave el botón de volver a correr NO se pinta: el endpoint responde 403. */
    canRerunEvaluations: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` cada lectura exige su clave. */
export function resolveModeliaAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = MODELIA_PERMISSIONS_ENFORCED,
): ModeliaAbilities {
    if (!enforce) {
        return { canViewEvaluations: true, canViewParameters: true, canRerunEvaluations: true };
    }
    return {
        canViewEvaluations: grantedPermissions.has(MODELIA_PERMISSIONS.viewEvaluations),
        canViewParameters: grantedPermissions.has(MODELIA_PERMISSIONS.viewParameters),
        canRerunEvaluations: grantedPermissions.has(MODELIA_PERMISSIONS.rerunEvaluations),
    };
}
